<template>
  <b-overlay :show="loading">
    <BatchesFilters
      :value="filters"
      :onChange="onChangeFilters"
      :clear="clearFilters"
    />
    <div class="text-left mb-2 d-flex justify-content-start align-items-center">
      <div
        class="my-2 text-primary"
        v-if="filteredBatches.length"
      >
        <b-form-checkbox
          class="d-inline-block"
          v-model="selectAll"
          @change="selectAllBatches"
        >
        </b-form-checkbox>
        Seleccionar todos
      </div>
      <BatchesOptionsMasive :selected-batches="selectedBatches"/>
      <b-button
        class="ml-4 badge-glow"
        variant="warning"
        size="sm"
        data-cy="download"
        v-on:click.once="onDownloadBatches"
      >
        <feather-icon
          icon="DownloadIcon"
          class="mr-3"
        />
        <span class="align-middle">Descargar</span>
      </b-button>
      <b-button
        class="badge-glow ml-3"
        variant="primary"
        size="sm"
        v-has-permission="'ED165'"
        @click="openBatchForm"
        data-cy="add"
        v-if="view !== 'batchs-review'"
      >
        <feather-icon
          icon="list"
          class="mr-50"
        />
        <span class="align-middle">Agregar lote</span>
      </b-button>
    </div>
    <BatchesHeader/>
    <div
      class="force-render"
      :key="forceRender"
    >
      <BatchesRow
        :is-massive="isMassive"
        :selected-batches="selectedBatches"
        :key="batch.loteId"
        v-for="batch in filteredBatches"
        :batch="batch"
        :select-batch="selectBatch"
        @select-check-batch="selectCheckBatch"
        @unselect-check-batch="unSelectCheckBatch"
        v-on:reload-list="handleReloadList"
        data-cy="file"
      />
    </div>
    <div class="row">
      <div class="col-3">
        <div class="mt-5">
          Mostrando <select
          v-model="rowspp"
          @change="fetchBatches()"
        >
          <option
            value="10"
            selected="selected"
          >10
          </option>
          <option value="15">15</option>
          <option value="30">30</option>
          <option value="50">50</option>
        </select> registros por página.
        </div>
      </div>
      <div class="col-9">
        <BatchesPagination
          :show="filteredBatches.length"
          v-model="page"
        />
      </div>
    </div>
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import BatchesFilters from '@/febos/aduanas/batches/views/components/BatchesFilters';
import BatchesHeader from '@/febos/aduanas/batches/views/components/BatchesHeader';
import BatchesPagination from '@/febos/aduanas/batches/views/components/BatchesPagination';
import BatchesRow from '@/febos/aduanas/batches/views/components/BatchesRow';
import BatchesOptionsMasive from '@/febos/aduanas/batches/views/components/BatchesOptionsMasive';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import { selectAllElements, fetchBatchesList, selectBatchState } from '@/febos/aduanas/batches/store/actions';
import { batches, loading } from '@/febos/aduanas/batches/store/getters';
import { batchesListSearch } from '@/febos/servicios/api/aduanas/batches.api';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';

export default {
  components: {
    BatchesHeader,
    BatchesRow,
    BatchesFilters,
    BatchesPagination,
    BatchesOptionsMasive
  },
  data() {
    return {
      view: this.$route.name,
      isMassive: false,
      selectAll: false,
      selectedBatches: [],
      filters: '',
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      page: Number.parseInt(this.$route.query.page || 1, 10),
      selectedBatch: {},
      searchParam: false,
      textSearch: '',
      forceRender: Date.now() // TODO: the files watch is triggered but the component not re-render.
    };
  },
  watch: {
    async page(page) {
      updateSearchParams({ page });
      await this.fetchBatches();
    }
  },
  computed: {
    ...mapGetters('batches', {
      batches: batches.name,
      loading: loading.name
    }),
    filteredBatches() {
      return this.batches;
    }
  },
  methods: {
    ...mapActions('batches', {
      selectAllElements: selectAllElements.name,
      selectBatchState: selectBatchState.name,
      fetchBatchesList: fetchBatchesList.name
    }),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    selectBatch(batch) {
      this.selectedBatch = batch;
      this.selectBatchState(batch.loteId);
    },
    clearFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 1 });
      this.$router.go();
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchBatches();
        }
      }
    },
    selectAllBatches() {
      this.selectAllElements(this.selectAll);
      if (this.selectAll) {
        this.isMassive = true;
        this.filteredBatches.forEach((batch) => {
          this.selectedBatches.push(batch);
        });
      } else {
        this.isMassive = false;
        this.selectedBatches = [];
      }
    },
    selectCheckBatch(batch) {
      this.selectedBatches.push(batch);
    },
    unSelectCheckBatch(batch) {
      this.selectedBatches = this.selectedBatches.filter((elm) => (elm.loteId !== batch.loteId));
    },
    getFilters() {
      if (this.$route.query?.filters) {
        if (this.$route.query.filters.includes('loteId')) { return this.$route.query.filters; }
      }
      return mergeFilters(this.filters, this.$route.query.filters);
    },
    fetchBatches() {
      this.fetchBatchesList({
        params: {
          filtros: this.getFilters(),
          orden: '-folio',
          paginaActual: this.page,
          elementosPorPagina: this.rowspp
        }
      });
    },
    async onDownloadBatches() {
      this.$vs.notify({
        title: 'Solicitando',
        text: 'Descargando archivos',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'primary',
        position: ALERT_POSITION
      });
      try {
        const { data } = await batchesListSearch({
          filters: this.getFilters(),
          order: '-folio',
          format: 'csv'
        });
        window.open(data.url, '_blank');
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Ocurrió un error al descargar los registros',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          position: ALERT_POSITION
        });
      }
    },
    openBatchForm() {
      this.$router.push({ name: 'pre-issue' });
    },
    handleReloadList() {
      this.fetchBatches();
    }
  },
  created() {
    this.closeModal();
    this.selectBatchState('');
  },
  mounted() {
    this.fetchBatches();
  }
};
</script>
